//
import { required } from "@/services/validations"

//
export default [
    {
        name: "name",
        type: "text-field",
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: "Nombre",
            readonly: true,
            rules: [ required ],
        },
    },
    {
        name: "query",
        type: "textarea",
        flex: {
            xs12: true,
        },
        props: {
            label: "Consulta",
            readonly: true,
            rules: [ required ],
        },
    },
]